export default __webpack_public_path__ + "static/media/lifecycle-of-flag.5d83cafc.svg";